import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchGetData } from '../../services/apiClient';
import { RootState } from '../../state/store';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface MetricsState {
  metrics: string[];
  selectedMetric: string[];
  loading: boolean;
}

const initialState: MetricsState = {
  metrics: [],
  selectedMetric: [],
  loading: false,
};

export const fetchMetrics = createAsyncThunk('metrics/fetchMetrics', async () => {
  const response = await fetchGetData<string[]>(API_ENDPOINTS.SCENARIO_INPUT.METRIC_FILTER_DATA);
  return response;
});

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    updateSelectedMetric: (state, action: PayloadAction<string[]>) => {
      state.selectedMetric = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMetrics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMetrics.fulfilled, (state, action) => {
      state.loading = false;
      state.metrics = action.payload;
      state.selectedMetric = [action.payload[0]];
    });
    builder.addCase(fetchMetrics.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { updateSelectedMetric } = metricsSlice.actions;

export const selectMetrics = (state: RootState) => state.metrics.metrics;
export const selectSelectedMetric = (state: RootState) => state.metrics.selectedMetric;
export const selectLoading = (state: RootState) => state.metrics.loading;

export default metricsSlice.reducer;
